import React, { ReactNode } from "react";

import { ReactComponent as IconSearch24 } from "../../icons/icon/24/a-icon-search-24.svg";
import { ReactComponent as IconSearchPopular24 } from "../../icons/icon/24/a-icon-searchpopular-24.svg";
import LinkButton from "../button/linkButton";

interface SearchTermProps {
  children: ReactNode;
  onClick: () => void;
  popular?: boolean;
}

const SearchTerm: React.FC<SearchTermProps> = ({
  children,
  onClick,
  popular = false,
}) => (
  <LinkButton variant="normal" onClick={onClick}>
    {popular
      ? <IconSearch24 className="mr-12 text-grey-medium" />
      : <IconSearchPopular24 className="mr-12 text-grey-medium" />}
    <div className="typo-label">{children}</div>
  </LinkButton>
);

export default SearchTerm;
